<script setup>
import { ref, watch } from 'vue';
import debounce from 'lodash/debounce';
import { FwbInput } from 'flowbite-vue';

import { useScheduleQuery } from '@/composables/schedule/use-schedule-query';

const emit = defineEmits(['apply']);

const query = useScheduleQuery();
const searchText = ref('');

function onApply () {
  onApplyDebounced.cancel();

  if (searchText.value === query.searchText.value) {
    return;
  }

  query.applySearchText(searchText.value);

  emit('apply');
}

function onClear () {
  searchText.value = '';
  query.clearSearchText();

  emit('apply');
}

const onApplyDebounced = debounce(onApply, 500);

// Keep the local state in sync with query state.
watch(
  query.searchText,
  (val) => { searchText.value = val ?? ''; },
  { immediate: true }
);

watch(searchText, onApplyDebounced);

</script>

<template>
  <FwbInput
    v-model.trim="searchText"
    ref="inputRef"
    :placeholder="$t('label.search')"
    data-component-element-id="media-search-filter-input"
    class="w-60 rounded-lg"
    input-class="rounded-lg block focus:outline-2 focus:outline-solid focus:outline-transparent focus:outline-offset-0 pr-7"
    size="sm"
    @change="onApply"
    @keyup.enter="onApply"
    @blur="onApply"
  >
    <template #suffix>
      <button
        v-if="searchText?.length > 0"
        type="button"
        class="absolute top-1 right-1.5 h-7 w-7 flex items-center cursor-pointer rounded-4xl bg-transparent hover:bg-gray-300 border-0!"
        data-component-element-id="media-search-filter-input-clear"
        :aria-label="$t('buttons.clearAll')"
        @click="onClear"
      >
        <BaseIconSvg
          name="flowbite:close-outline"
          class="w-4! h-4!"
        />
      </button>
    </template>
  </FwbInput>
</template>
